/**
 *  所有關於操作 API 的函式
 */

import login from './apis/login'
import school from './apis/school'
import forms from './apis/forms'
import form from './apis/form'
import comment from './apis/comment'
import manuals from './apis/manuals'
import qas from './apis/qas'
import competition from './apis/competition'
import lotteries from './apis/lotteries'
import lottery from './apis/lottery'
import vote from './apis/vote'
import config from './apis/config'
import info from './apis/info'
import dashboard from './apis/dashboard'

export default {
  login,
  school,
  forms,
  form,
  comment,
  manuals,
  qas,
  competition,
  lotteries,
  lottery,
  vote,
  config,
  info,
  dashboard,
}
